var _rect, _line, _line2, _polyline, _polygon, _polygon2, _line3, _rect2, _path, _rect3, _path2, _path3, _polyline2, _path4, _path5, _path6, _polygon3, _path7, _path8, _polygon4, _path9, _polyline3, _polyline4, _path10, _line4, _path11, _path12, _line5, _path13, _path14, _circle, _rect4, _line6, _circle2, _circle3, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect5, _rect6, _rect7, _line7, _line8, _path27, _line9, _path28, _path29, _polygon5, _rect8, _line10, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _line11, _path44, _path45, _path46, _ellipse, _ellipse2, _circle4, _circle5, _path47, _path48, _path49, _path50, _polygon6, _polygon7, _polygon8, _path51, _rect9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fondos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 696.28 683.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "hero-start-circuit",
    x: 0.4,
    y: 161.02,
    width: 201.73,
    height: 249.52,
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 34.69,
    y1: 196.03,
    x2: 34.69,
    y2: 387.05,
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 22.38,
    y1: 375.23,
    x2: 180.25,
    y2: 375.23,
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "44.75 360.64 84.92 292.73 133.78 303.98 166.28 203.34",
    fill: "none",
    stroke: "#235aa7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "684.18 373.9 668.78 373.9 603.99 373.9 603.99 497.15 668.78 497.15 668.78 509.13 695.91 509.13 695.91 373.9 684.18 373.9",
    fill: "#bababa",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "673.24 373.9 657.83 373.9 593.05 373.9 593.05 487.85 657.83 487.85 657.83 498.94 684.97 498.94 684.97 373.9 673.24 373.9",
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 695.91,
    y1: 509.13,
    x2: 695.93,
    y2: 615.31,
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 553.63,
    y: 422.04,
    width: 117.32,
    height: 118.12,
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M670.25,422V540.16H651.73a87.33,87.33,0,0,0,1.71-17.26c0-44.41-33-80.41-73.6-80.41s-73.6,36-73.6,80.41a87.33,87.33,0,0,0,1.7,17.26H489.43V422Z",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 382.81,
    y: 430.61,
    width: 106.62,
    height: 109.55,
    fill: "#bababa",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M670.25,422V540.16H651.73a87.33,87.33,0,0,0,1.71-17.26c0-44.41-33-80.41-73.6-80.41s-73.6,36-73.6,80.41a87.33,87.33,0,0,0,1.7,17.26H489.43V422Z",
    fill: "#bababa",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.25,380.48l13.44-13,6.08-5,14.91,22.67-23.23,16.49s-6.45,3.86-12.71,1.66c-5.45-1.92-13.05-27.65-18.07-34.2l18.07-3,6.59,9.52",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "86.7 333.42 84.92 335.73 105.2 374.68 136.59 371.64 163.62 363.54 144.67 333.41",
    fill: "#010101",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7,333.42l19.74,39.05,29.68-3.13,27.44-8.11S143.89,324.72,143.63,325s-26.3,8.59-26.3,8.59Z",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.34,332.21c1.72-4.06,10.45-.48,10.45-.48l3,13.46,14.4,7.48L163.94,360l-9.24-5.74-9.36-11-1.64-.65",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.25,333.93l-8.39-2a1.79,1.79,0,0,0-1.6.38l-6.63,5.53a1.22,1.22,0,0,0-.42,1.25c.29,1.11,1.36,2.65,5.27-.1l5.09-2.87",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "133.78 342.7 137.42 340.17 173.78 331.65 174.51 334.74 138.19 343.25 133.78 342.7",
    fill: "#010101",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.66,649.17s-36,21-40.49,32.86h35.17l5-5.94,5.64,6.68h9.39S204.93,652.37,186.66,649.17Z",
    fill: "#010101",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.79
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M219.8,651s-9.08,12.21-7.39,31.74h24.06l1.69-7,2.53,7h13.09S255.68,666,235,647.54Z",
    fill: "#010101",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.79
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "172.88 424 172.88 519.36 236.46 498.85 245.81 433.77 172.88 424",
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M244.86,436.85l7.38,227.83H212.91s-10.06-141.17-10.25-141.8",
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "169 432.55 166.45 473.01 158.9 664.68 200.58 664.68 220.29 465.07 230.18 465.07",
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "195.25 317.11 197.28 333.19 220.84 330.74 219.4 314.35",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M200.73,316.69c-9.21,9-18.54,3.61-21.63-.41-4.78-6.21,1.22-16,1.22-16a7.45,7.45,0,0,1-3.3-2.2,2.8,2.8,0,0,1,.53-4l5.83-4.41a5.76,5.76,0,0,0,1.77-2.23l3.25-7.23s11.25-10.15,25.14-1.94,15.34,11.6,15.34,11.6l-6.56,26.33",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 191.52,
    y1: 293.29,
    x2: 205.98,
    y2: 301.23,
    fill: "#010101",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M203.12,313.92c.17-2.29.17-3.46,1.46-5.41a7.94,7.94,0,0,0,1.73-3.74c.15-2.49-3.19-3.31-5.45-4.36-1.17-.54-3.39.24-3.44-1.19,0-.76,1.39-3.64,1.58-4.36.86-3.18-1.17-6.87-4-8.33-3.33-1.72-7.73-1.68-9.35-5.88a4.43,4.43,0,0,1,1.34-4.57,14.2,14.2,0,0,1,5.37-2.85c.49-.16,1-.31,1.48-.44l.18,0a25.43,25.43,0,0,1,4-.66c8.37-.71,17,1.45,23.57,6.83a27.7,27.7,0,0,1,6.71,7.64,23.89,23.89,0,0,1,3,12.32,25.17,25.17,0,0,1-.3,3.25c-1.53,9.28-1.21,19.09-1.84,22.09a3.06,3.06,0,0,1-2.36,2.36,63.17,63.17,0,0,1-10.27.8c-2.43,0-4.87-.05-7.3-.24-1.8-.13-3.3,0-4.75-1.28C202.24,323.84,202.92,316.61,203.12,313.92Z",
    fill: "#010101",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M200.13,301a4.67,4.67,0,0,1,4.67-2.78c4.4,0,4.74,6.63,2.71,9.55-3,4.34-6.77,2.44-6.77,2.44",
    fill: "#f4dcdc",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 185.59,
    y1: 289.63,
    x2: 184.27,
    y2: 288.83,
    fill: "#010101",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M201.05,306.05l3.5-4.14",
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M182.07,304.71a10.51,10.51,0,0,0,9.45,1.6",
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 314.98,
    cy: 203.34,
    r: 22.76,
    fill: "#fff396",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.79
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 296.88,
    y: 164.76,
    width: 36.2,
    height: 15.81,
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 314.98,
    x2: 314.98,
    y2: 164.76,
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.2,
    cy: 294.11,
    r: 4.9,
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 293.65,
    r: 1.71,
    fill: "#010101"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M174.24,344.84l3.13-2.89,16.76-7.56,2-4.91h28.94l1.94,6.44,1.87.58c2.72.83,8.43,2.15,10.67,3.9l4.53,3.53a11.64,11.64,0,0,1,4.36,7.52,85.44,85.44,0,0,1,.8,16c-.56,11.53-2,80.24-2,80.24H174.1l-2.76-4.24-1.65,4.24H164.6L169,387.84",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118,334.82c.23.38,17.38,32.63,17.38,32.63",
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M153.94,348.61c-2.66-5.91-6.88-5.14-8.3-8.06s-2.53-4.69-4.26-4.22.41,6.23,2,9.5,1.12,4.23,4.06,7.88,6.49,3.05,6.49,3.05l3.65.81S170,365.82,170,366.05",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M183.49,383.42l-15.65,13.26s-10.86-4.24-18.78-26.51l23.46-25.55a7.15,7.15,0,0,1,2.76-1.88l2.32-.88",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.3,325.74s2.31-.93,3.72,1.9l2.3,4s1.32,2.09-.65,2.43-3-.53-4.7-3S118.44,326.89,120.3,325.74Z",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M115.4,325.58s2.75-1.11,4.43,2.26l2.73,4.78s1.57,2.48-.76,2.88-3.6-.63-5.59-3.52S113.19,326.94,115.4,325.58Z",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M110.85,326.16s3-1.2,4.8,2.45l3,5.18s1.7,2.7-.83,3.13-3.9-.68-6.07-3.82S108.45,327.63,110.85,326.16Z",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M105.64,326.94s2.89-1.16,4.65,2.37l2.87,5s1.65,2.61-.8,3-3.78-.66-5.87-3.7S103.32,328.37,105.64,326.94Z",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M473.83,578.62,466.46,594a60.89,60.89,0,0,0-27.11,16.58,8.66,8.66,0,0,0-2.29,5.85h42.13l6.36-9.71v9.71H495.6l12-37.84Z",
    fill: "#010101",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M529.75,466.77s-19.42-6.4-34.49,33.49-36.16,84.06-36.16,84.06h50.56l35.67-84.73",
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M540.56,578.62,533.19,594a61,61,0,0,0-27.12,16.58,8.71,8.71,0,0,0-2.29,5.85h42.13l6.37-9.71v9.71h10l12.06-37.84Z",
    fill: "#010101",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M596.48,466.77s-19.42-6.4-34.49,33.49-36.17,84.06-36.17,84.06h50.57l35.67-84.73",
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 385.99,
    y: 402.05,
    width: 61.79,
    height: 19.99,
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 378.27,
    y: 382.06,
    width: 61.79,
    height: 19.99,
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 382.81,
    y: 362.07,
    width: 61.79,
    height: 19.99,
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 176.15,
    y1: 665.17,
    x2: 187.96,
    y2: 447.71,
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 233.01,
    y1: 664.68,
    x2: 227.45,
    y2: 465.07,
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.79
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M506.9,422.15c.25-.19,145.46,2.72,145.46,2.72l5.43-22,1.33-10.06-18-22.47A26.86,26.86,0,0,0,624,360.57l-28-4H561.13L541,359.67a26.85,26.85,0,0,0-13.13,5.94l-31.32,26.22-2.67,4.51",
    fill: "#fff396",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 571.9,
    y1: 384.59,
    x2: 571.9,
    y2: 421.46,
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M593.78,355.83a9.08,9.08,0,0,1-.73,3.27l-1.17-3.88s-5.54,14.38-13.59,16.85l-.81,5.88-5.58,6.64-7.69-10.69-1.41-24.52,23.74-23.53S593.78,348,593.78,355.83Z",
    fill: "#f4dcdc",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M593.05,359.1c-3.17,8-15.57,18.85-15.57,18.85l-2.63-7.64c8-2.47,17-18.23,17-18.23Z",
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "563.39 359.66 566.08 370.45 563.39 378.96 563.39 359.66",
    fill: "#dbdbdb",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 524.93,
    y: 401.98,
    width: 61.79,
    height: 19.99,
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 537.46,
    y1: 391.83,
    x2: 533.72,
    y2: 421.97,
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M528.72,416.64c.69-.15,9.87,1,15,1.39a1.79,1.79,0,0,1,1.73,1.71h0a1.81,1.81,0,0,1-1.81,1.72l-17.35.69-31.66-2.47,5.22-19.56,26.91,1.93",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M528.72,410.3c.76-.2,11.4,1.24,17.06,1.74a2.14,2.14,0,0,1,1.89,2.17h0a2.13,2.13,0,0,1-2,2.17l-19.07.87",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M524.21,405.71s14.38,1.46,19.52,1.92a2,2,0,0,1,1.73,2h0a1.94,1.94,0,0,1-1.81,2l-17.35.79",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M524.21,407.24l10.68-1.19c10.88.24,6.36-5,6.36-5l-26.62-1.19H497.31",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M496.57,391.83l-2.89,2.42c-2,1.65-6.44,6.71-6.45,9.29v3.9a14,14,0,0,0,10.52,13.71,10.14,10.14,0,0,0,2.48.31l17.28.35V400.17a5.08,5.08,0,0,0-4.68-5.06l-6.9-.54",
    fill: "#fff396",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M519.73,421.64l-5.53-.74a7.72,7.72,0,0,1-7.12-8l.25-5.58a7.72,7.72,0,0,1,7.93-7.37l3.88.11",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M587.37,416.64c-.69-.15-9.87,1-15,1.39a1.79,1.79,0,0,0-1.73,1.71h0a1.81,1.81,0,0,0,1.81,1.72l17.36.69,42.42-2.76L627,399.83l-37.68,2.22",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M587.37,410.3c-.75-.2-11.4,1.24-17.06,1.74a2.14,2.14,0,0,0-1.89,2.17h0a2.14,2.14,0,0,0,2,2.17l19.07.87",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M591.88,405.71s-14.38,1.46-19.52,1.92a2,2,0,0,0-1.73,2h0a1.94,1.94,0,0,0,1.81,2l17.36.79",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M591.88,407.24l-10.67-1.19c-10.89.24-6.37-5-6.37-5l26.62-1.19H628.8",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M645.47,394l-39.93,2.14a9.09,9.09,0,0,0-8.61,9.23l.28,16.67h55.36a11,11,0,0,0,11-11V405.8a21.13,21.13,0,0,0-4.64-13.21h0",
    fill: "#fff396",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M589.6,341.42c0,.38,0,.76-.05,1.13",
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M589.55,342.55s-.13.86-.23,2.18",
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M553.63,343.64s-6.54,6.51-4.83,15.3,9.49,1.48,9.11,1.06S553.63,343.64,553.63,343.64Z",
    fill: "#010101",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 593.05,
    y1: 359.12,
    x2: 593.05,
    y2: 359.1,
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M592.12,350.31l3.84-5-7.68-19.78s-9-6.81-9.81-6.24-25.52.57-26.09,1.42-4.54,11.62-4.54,12.73,2.88,5.37,2.88,5.37h0a50.4,50.4,0,0,1,.16,5.2c-1.32,14,9.9,19.61,19.45,19,8.77-.51,17.38-6.45,19-18.36Z",
    fill: "#f4dcdc",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M596.5,359.59c-7.93,1-7.94-10.14-7.57-15,.1-.71.17-1.43.22-2.18l-4.07,1.08c0-12.72-3.92-15.9-8.22-17.39s-11.23,1.87-19.28,2.43a24.4,24.4,0,0,1-8.36-.53,34.52,34.52,0,0,1,1.5,10.82,9.92,9.92,0,0,1-5-7.12c-.79-5-.44-9.73.62-12.36,2.41-5.95,11-10.58,22-11.84,27.23-3.13,29.28,25.13,29.84,31.49S606.6,358.29,596.5,359.59Z",
    fill: "#010101",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M588.28,345.34s7.49-.18,7.68-8.42-8.13-6.28-8.13.08l.28,5.83",
    fill: "#f4dcdc",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 573.36,
    cy: 338.41,
    rx: 4.93,
    ry: 3.01,
    transform: "translate(-58.1 127.42) rotate(-12.07)",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 555.83,
    cy: 338.41,
    rx: 3.01,
    ry: 4.93,
    transform: "translate(143.8 842.09) rotate(-82.05)",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 572.65,
    cy: 339.48,
    r: 1.87,
    fill: "#010101"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.47,
    cy: 339.48,
    r: 1.87,
    fill: "#010101"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M563.12,350.33a10.44,10.44,0,0,0,9.5-2",
    fill: "none",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M569,332.7a10.6,10.6,0,0,1,12.39.22",
    fill: "#f4dcdc",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M559.15,333.07a9.16,9.16,0,0,0-9.32-.46",
    fill: "none",
    stroke: "#010101",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M562.74,334.56A15.12,15.12,0,0,1,559,341a11.27,11.27,0,0,0-2.14,2.44,2.56,2.56,0,0,0,.25,3,3.64,3.64,0,0,0,3,.49l6-.78",
    fill: "#f4dcdc",
    stroke: "#1e1e1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "661.12 616.25 663.74 616.25 663.74 523.58 653.74 523.58 661.12 616.25",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "557.77 616.25 560.39 616.25 564.08 523.58 554.08 523.58 557.77 616.25",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "388.61 616.25 385.99 616.25 385.99 523.58 390.99 523.58 392.3 523.58 393.21 530.69 394.97 536.39 388.61 616.25",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M559.08,422V540.16H540.57a87.4,87.4,0,0,0,1.7-17.26c0-44.41-32.95-80.42-73.6-80.42s-73.59,36-73.59,80.42a87.4,87.4,0,0,0,1.7,17.26H378.27V422Z",
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 553.63,
    y: 422.04,
    width: 117.32,
    height: 118.12,
    fill: "#fff",
    stroke: "#1e1e1c",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.2de6f033.svg";
export { ForwardRef as ReactComponent };